import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import styles from './Input.css';

const Input = ({
  input,
  label,
  name,
  type,
  readOnly,
  minLength,
  maxLength,
  selected,
  blacklist,
  pattern,
  meta: { touched, initial, error, invalid },
}) => {
  const inputCopy = input;
  if (!blacklist) {
    inputCopy['data-hj-whitelist'] = '';
  }
  return (
    <div className={styles.inputField}>
      <input
        {...inputCopy}
        className={classnames(styles.input, {
          [styles.inputError]: (touched || initial) && error,
        })}
        type={type}
        name={name}
        readOnly={readOnly}
        minLength={minLength}
        maxLength={maxLength}
        checked={selected}
        pattern={pattern}
      />
      <div className={styles.helpText}>
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
        {(touched || initial) &&
          invalid && <span className={styles.errorMessage}>{error}</span>}
      </div>
    </div>
  );
};

Input.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object,
  readOnly: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  selected: PropTypes.bool,
  blacklist: PropTypes.bool,
  pattern: PropTypes.string,
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Forms/Input.jsx